export interface IconDefinition {
  name_en: string;
  name_nl: string;
  name_fr: string;
  name_de: string;
  svg: string;
}

type CompactIconDefinition = [string, string, string, string, string] | string[];

interface CompactIconData {
  columns: string[];
  icons: CompactIconDefinition[];
}

export function normalizeIconsData(
  input: IconDefinition[] | CompactIconData
): IconDefinition[] {
  if (Array.isArray(input)) {
    return input;
  }

  return input.icons.map(([name_en, name_nl, name_fr, name_de, svg]) => ({
    name_en,
    name_nl,
    name_fr,
    name_de,
    svg,
  }));
}
